
import Navbar from "@/components/Navbar";
import TokenDisplay from "@/components/TokenDisplay";
import GibRating from "@/components/GibRating";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import ImageHoverPopup from "@/components/ui/image-hover-popup";
import { Badge } from "@/components/ui/badge";
import { Wallet, LineChart, GraduationCap, Building2, Lightbulb, Briefcase } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

const JimProfile = () => {
  const user = {
    name: "Jim Lawnin",
    role: "iSPAI Chair and Advisor - Finance and Venture Capital",
    solutionBounties: 10,
    domains: ["Finance Strategy", "Venture Capital", "Business Growth", "Emerging Technologies", "Angel Investment", "Blockchain", "Cryptocurrency", "Financial Management", "Business Development"],
    industries: [{
      name: "Finance", 
      icon: Wallet
    }, {
      name: "Investment",
      icon: LineChart
    }, {
      name: "Education",
      icon: GraduationCap
    }, {
      name: "Enterprise",
      icon: Building2
    }, {
      name: "Innovation",
      icon: Lightbulb
    }, {
      name: "Consulting",
      icon: Briefcase
    }],
    confirmedSolutions: 38,
    confirmedKnowledgeBases: 75,
    tokenBalance: 220,
    bio: "Jim Lawnin leads the finance function for iSPAI while also Chairing the Board of Advisors. He brings over two decades of expertise in finance and business growth, specializing in emerging technologies. As co-founder of Sustainable Ventures Group, he guided corporations in deploying innovative technologies. His role as an Angel investor and board member for the Houston Angel Network highlights his understanding of early-stage investment. Jim has built two consulting firms to over $250 million in revenue, showcasing his ability to drive significant growth. His academic credentials include an MBA, an MSc in Blockchain and Cryptocurrency, and dual undergraduate degrees in Accounting and Engineering. A Chartered Financial Analyst (CFA) and former CPA with over 18 years at Arthur Andersen and Ernst & Young, Jim's financial strategy and management skills are exceptional. He has also judged business plan competitions at Rice and Stanford Universities and spoken on innovation at Harvard, underscoring his commitment to fostering startup success."
  };

  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="p-6 col-span-2">
            <div className="flex items-start justify-between mb-6">
              <div className="flex items-start space-x-6">
                <div className="flex flex-col items-center gap-4">
                  <ImageHoverPopup 
                    imageSrc="/lovable-uploads/2e70d58c-5d54-499c-abf5-4326e4935c06.png"
                    imageAlt="Jim Lawnin"
                  >
                    <Avatar className="h-36 w-36 cursor-pointer">
                      <AvatarImage src="/lovable-uploads/2e70d58c-5d54-499c-abf5-4326e4935c06.png" alt="Jim Lawnin" />
                      <AvatarFallback>JL</AvatarFallback>
                    </Avatar>
                  </ImageHoverPopup>
                  <div className="flex gap-2">
                    <Popover>
                      <PopoverTrigger asChild>
                        <Button variant="outline" size="sm" className="bg-white text-black hover:bg-gray-100">
                          BIO
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent className="w-96">
                        <div className="space-y-2">
                          <h4 className="text-lg font-semibold">Jim Lawnin</h4>
                          <p className="text-sm text-gray-600">{user.bio}</p>
                        </div>
                      </PopoverContent>
                    </Popover>
                    <Button variant="outline" size="sm" className="bg-white text-black hover:bg-gray-100">
                      NW
                    </Button>
                  </div>
                  <div className="w-full">
                    <h3 className="font-serif text-xl font-semibold text-black mb-3">Industries</h3>
                    <div className="grid grid-cols-1 gap-2">
                      {user.industries.map(industry => {
                      const Icon = industry.icon;
                      return <div key={industry.name} className="flex items-center space-x-2 p-3 border-2 border-black rounded-lg">
                            <Icon className="h-5 w-5 text-black" />
                            <span className="text-sm font-medium text-black">{industry.name}</span>
                          </div>;
                    })}
                    </div>
                  </div>
                </div>
                <div>
                  <h2 className="font-serif text-3xl font-bold text-black mb-2">{user.name}</h2>
                  <div className="flex items-center gap-2 mb-4">
                    <span className="text-lg font-medium text-black">{user.role}</span>
                    <a href="/ispai-channel" className="ml-2">
                      <img 
                        src="/lovable-uploads/d7afdb11-1c93-4596-9b11-91cb70981610.png" 
                        alt="iSPAI Channel" 
                        className="w-16 h-16 hover:scale-110 transition-transform"
                      />
                    </a>
                  </div>
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <Card className="p-6">
                      <div className="flex flex-col items-center">
                        <h3 className="font-serif text-xl font-semibold text-black mb-2">Solution Bounties</h3>
                        <span className="text-4xl font-bold mb-2">{user.solutionBounties}</span>
                        <Link to="/solution-bounties/jim" className="text-sm text-blue-600 hover:text-blue-800">
                          View Details →
                        </Link>
                      </div>
                    </Card>
                    <GibRating rating={9.7} />
                    <Card className="p-6">
                      <div className="flex flex-col items-center">
                        <h3 className="font-serif text-xl font-semibold text-black mb-2">Confirmed Solutions</h3>
                        <span className="text-4xl font-bold">{user.confirmedSolutions}</span>
                      </div>
                    </Card>
                    <Card className="p-6">
                      <div className="flex flex-col items-center">
                        <h3 className="font-serif text-xl font-semibold text-black mb-2">Knowledge Bases</h3>
                        <span className="text-4xl font-bold">{user.confirmedKnowledgeBases}</span>
                      </div>
                    </Card>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          
          <div className="space-y-6">
            <TokenDisplay balance={user.tokenBalance} />
            <Card className="p-6">
              <h3 className="font-serif text-xl font-semibold text-black mb-3">Domains</h3>
              <div className="flex flex-wrap gap-2">
                {user.domains.map(domain => <Badge key={domain} variant="outline" className="border-2 border-black text-black">
                    {domain}
                  </Badge>)}
              </div>
            </Card>
          </div>
        </div>
      </main>
    </div>
  );
};

export default JimProfile;
